export default __webpack_public_path__ + "static/media/sorry_tagline.32c3b2e9.png";